import { useEffect } from 'react';
import { api } from '../../server/api';
import { useParams } from 'react-router-dom';
import { HelmetComponent } from '../../components/Helmet';
import unsubscribe from '../../assets/images/unsubscribe.png';

export function Unsubscribe() {
  const { clientId, playerId } = useParams();
  useEffect(() => {
    async function unsubscribePlayer() {
      const parameters = {
        userType: 'consumer',
        updateFunctionality: 'unsubscribeEmail',
        clientId,
        playerId,
      };

      await api.post(`/update`, parameters).catch((error) => {
        console.log('Erro ao Descadastrar', error);
      });
    }
    unsubscribePlayer();
  }, []);

  return (
    <>
      <HelmetComponent tabTitle={'Descadastrar'} />
      <div className="container pt-5 text-center">
        <div className="d-flex flex-column justify-content-center align-items-center">
          <div className="my-5 w-1">
            <img src={unsubscribe} />
          </div>
          <div className="mt-5 mb-3 fw-bold fs-3">
            Confirmação de descadastro
          </div>
          <div className="my-2 fs-4">
            Agora que você não receberá mais emails da nossa plataforma.
          </div>
        </div>
      </div>
    </>
  );
}
